import { defineComponent as _defineComponent } from 'vue'
import RoundedButton from './RoundedButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'RelatedTopics',
  setup(__props) {


return { __sfc: true,RoundedButton }
}

})